// @ts-nocheck
import React from 'react';
import Spinner from '@guestyci/foundation/Spinner';

/* eslint-disable import/no-unresolved */
const RemoteSmartLocksPage = React.lazy(
  () => import('RemoteSmartLocksPage/App')
);
const RemoteCapitalPage = React.lazy(
  () => import('RemoteAddOnsCenterPage/CapitalPage')
);
const RemoteGfhDynamicPricingPage = React.lazy(
  () => import('RemoteGfhDynamicPricingPage/App')
);
const RemoteGfhDptLayoutDialogsContainer = React.lazy(
  () => import('RemoteGfhDynamicPricingPage/LayoutDialogsContainer')
);
const RemoteGFHBookingCom = React.lazy(() => import('RemoteGfhBookingCom/App'));
const RemoteGfhShieldPage = React.lazy(() => import('RemoteGfhShieldPage/App'));
const RemoteGfhVrboIntegration = React.lazy(
  () => import('RemoteGfhVrboIntegration/App')
);
const RemoteGfhAddNewReservationPage = React.lazy(
  () => import('RemoteGfhAddNewReservationPage/App')
);
const RemoteGfhAirbnbOnboardingPage = React.lazy(
  () => import('RemoteGfhAirbnbOnboardingPage/App')
);
const RemoteGfhPaymentProcessorsPage = React.lazy(
  () => import('RemoteGfhPaymentProcessorsPage/App')
);
const RemoteGfhMarkupRates = React.lazy(
  () => import('RemoteGfhMarkupRates/App')
);
/* eslint-enable import/no-unresolved */

const getRemoteApp = (repositoryName: string) => {
  console.log('repositoryName: ', repositoryName);
  switch (repositoryName) {
    case 'gfh-dynamic-pricing-page':
      return RemoteGfhDynamicPricingPage;
    case 'gfh-dynamic-pricing-page/LayoutDialogsContainer':
      return RemoteGfhDptLayoutDialogsContainer;
    case 'smart-locks-page':
      return RemoteSmartLocksPage;
    case 'add-ons-center-page/capital':
      return RemoteCapitalPage;
    case 'gfh-booking-com':
      return RemoteGFHBookingCom;
    case 'gfh-shield-page':
      return RemoteGfhShieldPage;
    case 'gfh-vrbo-integration':
      return RemoteGfhVrboIntegration;
    case 'gfh-add-new-reservation-page':
      return RemoteGfhAddNewReservationPage;
    case 'gfh-airbnb-onboarding-page':
      return RemoteGfhAirbnbOnboardingPage;
    case 'gfh-payment-processors-page':
      return RemoteGfhPaymentProcessorsPage;
    case 'gfh-markup-rates':
      return RemoteGfhMarkupRates;
    default:
      console.error(
        `Cannot load ${repositoryName}. Update ModuleFederationApp component`
      );
      return Spinner;
  }
};

export const getRemoteAppProps = (repositoryName: string, baseUrl: string) => {
  switch (repositoryName) {
    case 'add-ons-center-page/capital':
      return {
        baseUrl,
        isGFH: true,
      };
    default:
      return { baseUrl };
  }
};

export default getRemoteApp;
